import React, {useEffect} from "react";
import MessagePreloader from "../MessagePreloader/MessagePreloader";
import "./ChatMessage.css";

const ChatMessage = ({message}) => {
  const time = message.timestamp ? new Date(message.timestamp) : new Date();
  const formattedTime = time.toLocaleTimeString([], {hour: "2-digit", minute: "2-digit"});

  const containerClass = `chat-message-container ${message.type === "image" ? "message--sent" : "message--received"}`;

  useEffect(() => {
    return () => {
      if (message.type === "image" && message.content.startsWith("blob:")) {
        URL.revokeObjectURL(message.content);
      }
    };
  }, [message]); /* fix: */

  return (
    <div className={containerClass}>
      {message.type === "image" ? (
        <img src={message.content} alt="Отправленное изображение" className="chat-image" />
      ) : message.type === "loader" ? (
        <div className="chat-loader">
          <MessagePreloader />
        </div>
      ) : message.type === "custom" ? (
        <div className="chat-text chat-custom">{message.content}</div>
      ) : (
        <p className="chat-text">{message.content}</p>
      )}
      <span className="chat-time">{formattedTime}</span>
    </div>
  );
};

export default ChatMessage;
